const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
};

/**
 * A default form handler for posting to Netlify Forms.
 * @param {Object} values   The form values.
 * @param {Object} actions  The formik "bag", containing the setSubmitting action.
 * @param {string} path     The path to post the values to.
 * @return {Promise} The promise that can be used to handle results.
 */
export default function handleNetlifySubmit(
  values,
  { setSubmitting },
  path = '/'
) {
  return fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: encode(values),
  }).then(() => setSubmitting(false));
}
